<div class="flex h-full w-full">
  <div class="grid h-full w-[288px] shrink-0 rounded-r-4xl bg-background-white shadow-card">
    @if (!isLoading()) {
      @if (highlightedTeeth().length > 0) {
        <lib-teeth-highlight [teeth]="highlightedTeeth()" />
      } @else {
        <div class="flex h-full w-full items-center justify-center">
          <p class="typo-h4-semibold w-26 text-center text-text-light">{{ 'charting_treatment_plan_no_tooth' | translate }}</p>
        </div>
      }
    }
  </div>
  <div class="flex flex-1 flex-col gap-4 p-4">
    <div class="flex shrink-0 flex-col gap-2">
      <div class="flex items-center justify-between">
        <div class="typo-h2 inline-flex text-text-primary">{{ 'charting_treatment_plan_title' | translate }}</div>
        <button class="inline-flex" (click)="onCloseClick()">
          <svg-icon class="text-text-primary" key="px-24-x" size="md"></svg-icon>
        </button>
      </div>

      <div class="typo-h4-light text-text-tertiary">
        {{ 'charting_treatment_plan_subtitle' | translate }}
      </div>

      <div class="flex items-center gap-4">
        <lib-input
          class="flex-1"
          [value]="searchQuery()"
          [label]="'charting_treatment_plan_search_placeholder' | translate"
          background="white"
          (valueChange)="onSearchQueryChange($event)"
        >
          <svg-icon class="text-text-tertiary" key="px-24-search" leftIcon></svg-icon>
        </lib-input>
        <lib-dropdown
          background="white"
          [options]="[
            {
              value: TreatmentPlanDialogDate.All,
              label: 'charting_treatment_plan_date_all' | translate
            },
            {
              value: TreatmentPlanDialogDate.Recent,
              label: 'charting_treatment_plan_date_recent' | translate
            },
            {
              value: TreatmentPlanDialogDate.Last6Months,
              label: 'charting_treatment_plan_date_last_6_months' | translate
            },
            {
              value: TreatmentPlanDialogDate.Last12Months,
              label: 'charting_treatment_plan_date_last_12_months' | translate
            }
          ]"
          [value]="dateOption()"
          (valueChange)="onDateOptionChange($event)"
        />
      </div>
    </div>
    <div class="flex flex-1 flex-col gap-4 overflow-hidden">
      <div class="grid flex-1 grid-cols-[1fr_max-content_max-content] grid-rows-[max-content_1fr] gap-x-12 gap-y-2 overflow-hidden">
        <div class="typo-h5-light col-start-1 col-end-[-1] grid grid-cols-subgrid px-6 text-text-tertiary">
          <div>{{ 'charting_treatment_plan_table_treatment' | translate }}</div>
          <div class="justify-self-center">{{ 'charting_treatment_plan_table_estimated_cost' | translate }}</div>
        </div>
        <div class="relative col-start-1 col-end-[-1] grid auto-rows-min grid-cols-subgrid gap-y-2 overflow-y-auto overflow-x-hidden">
          @if (isLoading()) {
            <ng-lottie class="absolute place-self-center" [options]="lottieOptions"></ng-lottie>
          } @else {
            @if (!treatmentList().length) {
              <div class="absolute flex h-full w-full flex-col items-center justify-center gap-2 text-text-light">
                <p class="typo-h4-semibold">{{ 'charting_treatment_plan_no_treatment_title' | translate }}</p>
                <p class="typo-h5-book">{{ 'charting_treatment_plan_no_treatment_subtitle' | translate }}</p>
              </div>
            }
            @for (treatment of treatmentList(); track $index) {
              <lib-treatment-card
                [treatment]="treatment"
                [providers]="providers()"
                (providerChange)="onTreatmentProviderChange($index, $event)"
                (toggle)="onTreatmentToggle($index)"
              />
            }
          }
        </div>
      </div>

      <div class="flex items-center justify-between">
        <div class="flex gap-2.5">
          <div class="flex items-center">
            <svg-icon class="text-secondary-green" size="sm" key="px-16-check"></svg-icon>
            <div class="typo-h5-light text-text-tertiary">
              {{ 'charting_treatment_plan_treatment_selected' | translate: { input1: numberOfselectedTreatments() } }}
            </div>
          </div>
          <div class="h-5 w-px bg-background-extra-light"></div>
          <div class="flex items-center">
            <div class="typo-h5-light text-text-tertiary">
              {{ 'charting_treatment_plan_total_estimated_cost' | translate: { input1: '&nbsp;' } }}
            </div>
            <div class="typo-h5-semibold text-text-primary">{{ treatmentsCostSum() | currency: 'USD' : 'symbol' : '1.0-0' }}</div>
          </div>
        </div>
        <div class="flex gap-6">
          <button class="btn-text" (click)="onCloseClick()">{{ 'charting_add_treatment_cancel_button' | translate }}</button>
          <button class="btn-primary py-3 shadow-none" [disabled]="numberOfselectedTreatments() === 0" (click)="onReviewClick()">
            {{ 'charting_treatment_plan_review_button' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
